import { Injectable, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterStateSnapshot, TitleStrategy } from '@angular/router';

import { EntornoService } from './entorno.service';

/** El que lleva `index.html`, para las rutas que no declaran título propio. */
const TITULO_APP = 'TCG Factory ERP';

/**
 * Antepone el entorno al título del documento: `[DEV] Dashboard — TCG Factory ERP`.
 *
 * <h3>Por qué una estrategia y no ponerlo una vez al arrancar</h3>
 * Las rutas ya traen su propio `title` (`app.routes.ts` y los `*.routes.ts` de cada dominio), y la
 * estrategia por defecto de Angular lo escribe en `document.title` en **cada** navegación. Un
 * prefijo puesto al arrancar lo borraría la primera navegación. La estrategia es el único punto por
 * el que pasan todos los casos.
 *
 * <h3>Va DELANTE</h3>
 * Los títulos de ruta ya terminan en «— TCG Factory ERP», así que la cola es lo primero que se pierde
 * al estrechar la pestaña. Delante, el entorno es justo lo que sobrevive, que es para lo que está.
 *
 * <h3>Las rutas sin título vuelven al nombre de la app</h3>
 * La estrategia por defecto, cuando una ruta no declara título, **deja el anterior**: te quedabas con
 * el título de la pantalla de la que venías. Aquí se repone `TCG Factory ERP`, de paso, para que el
 * prefijo no acabe pegado al título de otra pantalla.
 *
 * En producción no toca nada: `prefijoTitulo` es cadena vacía.
 */
@Injectable({ providedIn: 'root' })
export class EntornoTitleStrategy extends TitleStrategy {
  private readonly title = inject(Title);
  private readonly entorno = inject(EntornoService);

  override updateTitle(snapshot: RouterStateSnapshot): void {
    const tituloRuta = this.buildTitle(snapshot) ?? TITULO_APP;
    this.title.setTitle(`${this.entorno.descriptor().prefijoTitulo}${tituloRuta}`);
  }
}
